import React, { useState, useEffect } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Button,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Avatar,
  IconButton,
  Tooltip,
  Card,
  CardContent,
  Divider,
  Badge,
  useTheme,
  TablePagination,
  alpha,
  Menu,
  MenuItem, LinearProgress, Tab, Tabs, Snackbar, Alert, Modal,
  Pagination,
  Select,
  FormControl
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  Search as SearchIcon,
  CheckCircle as CheckIcon,
  Cancel as CloseIcon,
  Info as InfoIcon,
  FilterList as FilterIcon,
  MoreVert as MoreVertIcon,
  ArrowBack as ArrowBackIcon,
  Event as EventIcon,
  Person as PersonIcon,
  Refresh,
} from '@mui/icons-material';
import axios from 'axios';
import {axiosInstance, localAxiosGet, localAxiosPut } from '../../../../Axios/axios';
import TokenExpirePopup from '../../../../components/TokenExpirePopup';
import { useNavigate } from 'react-router-dom';

const leaveTypeColors = {
  'Casual Leave': '#2196f3',
  'Sick Leave': '#f44336',
  'Earned Leave': '#4caf50',
  'Maternity Leave': '#9c27b0',
};

const getInitials = (name) => {
  if (!name) return '';
  return name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase();
};


const LeaveRequestsWithSnackbar = () => {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={5000}
    >
      <LeaveRequests />
    </SnackbarProvider>
  );
};

export const LeaveRequests = () => {
  const theme = useTheme();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [requests, setRequests] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [pagination, setPagination] = useState({
    page: 0,
    limit: 10,
    totalPages: 0,
    totalRecords: 0
  })
  const [loading, setLoading] = useState(true);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [statusFilter, setStatusFilter] = useState('ALL');
  const [allLeaveTypes, setAllLeaveTypes] = useState([]);
  const [selectedLeaveTypeFilter, setSelectedLeaveTypeFilter] = useState('All')
  const [error, setError] = useState(null);

  const token = localStorage.getItem('accessToken');
  const organization_id = localStorage.getItem('organizationId');

  const [openEmployeeDetails, setOpenEmployeeDetails] = useState(false);
  const [employeeDetailsData, setEmployeeDetailsData] = useState(null);
  const [approvalComment, setApprovalComment] = useState('');
  const [rejectionReason, setRejectionReason] = useState('');
  const [actionTab, setActionTab] = useState(0);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
  const navigate = useNavigate();
  const [leaveRequests, setLeaveRequests] = useState([]);

  const handleCloseTokenExpirePopup = () => {
    setOpenTokenExpirePopup(false);
    navigate('/');
  };


  const showNotification = (message, variant) => {
    enqueueSnackbar(message, {
      variant: variant,
      preventDuplicate: true,
      action: (key) => (
        <IconButton size="small" onClick={() => closeSnackbar(key)} color="inherit">
          <CloseIcon fontSize="small" />
        </IconButton>
      )
    });
  };



  useEffect(() => {
    fetchLeaveRequests();
  }, [pagination.page, pagination.limit, searchTerm, selectedLeaveTypeFilter]);

  useEffect(() => {
    const fetchAllLeaveTypes = async () => {
      try {
        const response = await axiosInstance(localAxiosGet(`/organization/getAllLeaveTypes?organization_id=${organization_id}`, token));
        if (response.data.status === 'SUCCESS') {
          setAllLeaveTypes(response.data.message.leaveTypes || []);
        }
      } catch (error) {
        console.error('Error while fectching all leave types', error)
      }
    }
    fetchAllLeaveTypes();
  }, [])

  const fetchLeaveRequests = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      setLoading(true);
      const params = new URLSearchParams({
        organization_id: organization_id,
        page: pagination.page + 1,
        limit: pagination.limit,
      })

      if (selectedLeaveTypeFilter && selectedLeaveTypeFilter !== 'All'){

      params.append('leave_type_id', selectedLeaveTypeFilter);
      }
      if (searchTerm && searchTerm.length >=2){
         params.append('name', searchTerm);
      }

      // const config = localAxiosGet(`/organization/getAllLeaveRequestsByOrgId?organization_id=${organization_id}`, token);
      const config = localAxiosGet(`/organization/getAllLeaveRequestsByOrgId?${params}`, token);
      const response = await axiosInstance(config);

      // console.log('Leave Requests Response:', response.data);

      if (response.data.statusCode === 200 && response.data.status === "SUCCESS") {
        const leaveRequestsData = response.data.result.data || [];

        // console.log('Processing leave requests data:', leaveRequestsData);


        const transformedData = await Promise.all(leaveRequestsData.map(async (request, index) => {
          // console.log(`Processing request ${index + 1}/${leaveRequestsData.length}:`, request);


          let statistics = {};

          try {

            // console.log(`Fetching leave balance for user ${request.user_id}...`);
            const balanceResponse = await axiosInstance(localAxiosGet(`/organization/getAllLeaveTypesByEmpId?user_id=${request.user_id}`, token));
            const balanceData = balanceResponse.data;

            // console.log(`Leave Balance for User ${request.user_id}:`, balanceData);

            if (balanceData.statusCode === 200 &&
              balanceData.status === "SUCCESS" &&
              balanceData.message &&
              Array.isArray(balanceData.message.leaveTypesWithBalance)) {


              balanceData.message.leaveTypesWithBalance.forEach(leaveType => {

                let typeKey = leaveType.leave_type.toLowerCase().replace(/\s+/g, '_');


                statistics[typeKey] = {
                  total: leaveType.allocated_days || 0,
                  used: leaveType.used_days || 0,
                  remaining: leaveType.remaining || 0,
                  leaveTypeId: leaveType.leave_type_id,
                  leaveTypeName: leaveType.leave_type
                };
              });

              // console.log(`Leave types assigned to user ${request.user_id}:`, Object.keys(statistics));
              // console.log(`Statistics for user ${request.user_id}:`, statistics);

            } else {
              console.warn(`Leave balance data for user ${request.user_id} is not in expected format:`, balanceData);

              statistics = {};
            }

          } catch (balanceError) {
            console.error(`Error fetching leave balance for user ${request.user_id}:`, balanceError);
            console.error('Balance error details:', balanceError.response?.data || balanceError.message);

            if (balanceError.response && balanceError.response.status === 401) {
              // console.log('Token expired during balance fetch');
              setOpenTokenExpirePopup(true);
              return null;
            }


            statistics = {};
            // console.log('Using empty statistics due to balance fetch error');
          }


          const transformedRequest = {
            id: request.leave_id,
            userId: request.user_id,
            employeeName: request.employee_name,
            employeeId: request.emp_id,
            // employeeId: `EMP${request.user_id}`,
            department: request.department || 'N/A',
            avatar: request.employee_name
              ? request.employee_name
                .split(' ')
                .slice(0, 2)
                .map((name) => name.charAt(0))
                .join('')
                .toUpperCase()
              : 'U',
            leaveType: request.leave_type,
            reason: request.reason || 'Not provided',
            status: request.status,
            days: request.leave_duration || 0,
            fromDate: request.start_date ? new Date(request.start_date).toISOString().split('T')[0] : '',
            toDate: request.end_date ? new Date(request.end_date).toISOString().split('T')[0] : '',
            appliedOn: new Date().toISOString().split('T')[0],
            statistics: statistics,
            reportingManager: request.report_manager_name,

            name: request.employee_name,
            workingIn: request.department || 'N/A',
            duration: request.leave_duration?.toString() || '0',
            startDate: request.start_date,
            endDate: request.end_date
          };

          // console.log(`Transformed request ${index + 1}:`, transformedRequest);
          return transformedRequest;
        }));


        const paginationData = response.data.result.pagination || [];
        setPagination(prev => ({
          ...prev,
          totalPages: paginationData.totalPages || 0,
          totalRecords: paginationData.totalRecords || 0
        }))
        const validData = transformedData.filter(item => item !== null && item !== undefined);

        // console.log('Valid transformed data:', validData);
        // console.log(`Successfully processed ${validData.length} out of ${leaveRequestsData.length} requests`);


        const sortedData = [...validData].sort((a, b) => b.id - a.id);

        // console.log('Final sorted data:', sortedData);

        setRequests(sortedData);
        setLeaveRequests(sortedData);

        showNotification('Leave requests and balances loaded successfully', 'success');

      } else {
        console.error('API response error:', response.data);
        throw new Error(response.data.message || 'Failed to fetch leave requests');
      }

    } catch (err) {
      console.error('Error in fetchLeaveRequests:', err);
      console.error('Error details:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        stack: err.stack
      });

      if (err.response && err.response.status === 401) {
        setOpenTokenExpirePopup(true);
      } else {
        // More specific error message
        const errorMessage = err.response?.data?.message ||
          err.message ||
          'Error fetching leave requests. Please try again.';
        setError(errorMessage);
        showNotification(errorMessage, 'error');
      }
    } finally {
      // console.log('Setting loading to false');
      setLoading(false);
    }
  };


  const fetchEmployeeLeaveBalance = async (userId) => {
    try {
      console.log(`Fetching updated leave balance for user ${userId}...`);
      const config = localAxiosGet(`/organization/getAllLeaveTypesByEmpId?user_id=${userId}`, token);
      const balanceResponse = await axiosInstance(config);
      const balanceData = balanceResponse.data;

      console.log(`Updated Leave Balance for User ${userId}:`, balanceData);

      let statistics = {};

      if (balanceData.statusCode === 200 &&
        balanceData.status === "SUCCESS" &&
        balanceData.message &&
        Array.isArray(balanceData.message.leaveTypesWithBalance)) {


        balanceData.message.leaveTypesWithBalance.forEach(leaveType => {

          let typeKey = leaveType.leave_type.toLowerCase().replace(/\s+/g, '_');


          statistics[typeKey] = {
            total: leaveType.allocated_days || 0,
            used: leaveType.used_days || 0,
            remaining: leaveType.remaining || 0,
            leaveTypeId: leaveType.leave_type_id,
            leaveTypeName: leaveType.leave_type
          };
        });

        console.log(`Updated statistics for user ${userId}:`, statistics);
      }

      return statistics;
    } catch (error) {
      console.error(`Error fetching updated leave balance for user ${userId}:`, error);
      if (error.response && error.response.status === 401) {
        setOpenTokenExpirePopup(true);
      }
      return null;
    }
  };


  const handleLeaveApproval = async (employeeId, action, comment = '') => {
    try {
      setLoading(true);
      const token = localStorage.getItem('accessToken');

      if (!token) {
        throw new Error('Authentication token not found. Please login again.');
      }

      const requestBody = {
        comment: action === 'approve' ? comment : rejectionReason,
        status: action === 'approve' ? "APPROVED" : "REJECTED"
      };

      console.log('Request payload:', requestBody);

      const response = await axiosInstance(localAxiosPut(`/organization/approveLeave/${employeeId}`, requestBody, token));

      if (response.data.statusCode !== 200) {
        console.error('API Error Response:', response.data);
        throw new Error(`Server returned ${response.status}: ${response.statusText}`);
      }

      const data = response.data;

      if (data.statusCode === 401) {
        throw new Error('Your session has expired. Please login again.');
      }

      if (data.statusCode !== 200) {
        throw new Error(data.message || `Failed to ${action} leave request`);
      }


      const employeeRequest = requests.find(req => req.id === employeeId);

      if (employeeRequest && action === 'approve') {

        console.log('Fetching updated leave balance after approval...');
        const updatedBalance = await fetchEmployeeLeaveBalance(employeeRequest.userId);

        if (updatedBalance) {

          setRequests(prevRequests =>
            prevRequests.map(request =>
              request.id === employeeId
                ? {
                  ...request,
                  status: "APPROVED",
                  statistics: updatedBalance
                }
                : request
            )
          );

          setLeaveRequests(prevRequests =>
            prevRequests.map(request =>
              request.id === employeeId
                ? {
                  ...request,
                  status: "APPROVED",
                  statistics: updatedBalance
                }
                : request
            )
          );


          if (employeeDetailsData && employeeDetailsData.id === employeeId) {
            setEmployeeDetailsData(prev => ({
              ...prev,
              status: "APPROVED",
              statistics: updatedBalance
            }));
          }
        } else {

          setRequests(prevRequests =>
            prevRequests.map(request =>
              request.id === employeeId
                ? { ...request, status: "APPROVED" }
                : request
            )
          );

          setLeaveRequests(prevRequests =>
            prevRequests.map(request =>
              request.id === employeeId
                ? { ...request, status: "APPROVED" }
                : request
            )
          );
        }
      } else {

        setRequests(prevRequests =>
          prevRequests.map(request =>
            request.id === employeeId
              ? { ...request, status: action === 'approve' ? 'APPROVED' : 'REJECTED' }
              : request
          )
        );

        setLeaveRequests(prevRequests =>
          prevRequests.map(request =>
            request.id === employeeId
              ? { ...request, status: action === 'approve' ? 'APPROVED' : 'REJECTED' }
              : request
          )
        );
      }

      setOpenEmployeeDetails(false);

      setSnackbar({
        open: true,
        message: data.message || `Leave request ${action === 'approve' ? 'approved' : 'rejected'} successfully.${action === 'approve' ? ' Leave balance updated.' : ''}`,
        severity: 'success'
      });

      if (action === 'approve') {
        setApprovalComment('');
      } else {
        setRejectionReason('');
      }

    } catch (error) {
      console.error('Error in handleLeaveApproval:', error);

      if (error.message.includes('authentication') || error.message.includes('session') ||
        error.message.includes('token')) {
        setSnackbar({
          open: true,
          message: error.message,
          severity: 'error',
          action: (
            <Button color="inherit" size="small" onClick={() => {
              window.location.href = '/login';
            }}>
              Login
            </Button>
          )
        });
      } else {
        setSnackbar({
          open: true,
          message: error.message || `Failed to ${action} leave request`,
          severity: 'error'
        });
      }
    } finally {
      setLoading(false);
      fetchLeaveRequests();
    }
  };


  const handleApproveReject = async (id, status) => {
    try {
      const requestToUpdate = requests.find(req => req.id === id);

      if (!requestToUpdate) {
        showNotification('Request not found', 'error');
        return false;
      }


      const updatedRequests = requests.map(req =>
        req.id === id ? { ...req, status: status } : req
      );
      setRequests(updatedRequests);

      console.log(`Attempting to ${status.toLowerCase()} leave request with leave_id: ${id}`);

      const payload = {
        comment: null,
        status: status
      };
      console.log("Sending payload:", payload);

      const config = localAxiosPut(`/organization/approveLeave/${id}`, payload, token);
      const response = await axiosInstance(config);
      console.log("API Response:", response.data);

      if (response.data && response.data.status === "SUCCESS") {

        if (status === 'APPROVED') {
          console.log('Fetching updated leave balance after approval...');
          const updatedBalance = await fetchEmployeeLeaveBalance(requestToUpdate.userId);

          if (updatedBalance) {

            const updatedRequestsWithBalance = requests.map(req =>
              req.id === id ? { ...req, status: status, statistics: updatedBalance } : req
            );
            setRequests(updatedRequestsWithBalance);
            setLeaveRequests(updatedRequestsWithBalance);

            showNotification(`Leave request ${status.toLowerCase()} successfully. Leave balance updated.`, 'success');
          } else {
            showNotification(`Leave request ${status.toLowerCase()} successfully.`, 'success');
          }
        } else {
          showNotification(`Leave request ${status.toLowerCase()} successfully`, 'success');
        }

        if (detailsOpen) {
          setDetailsOpen(false);
        }
        return true;
      } else {
        const errorMessage = response.data?.message || `Failed to ${status.toLowerCase()} request`;
        showNotification(errorMessage, 'error');


        const revertedRequests = requests.map(req =>
          req.id === id ? { ...req, status: 'PENDING' } : req
        );
        setRequests(revertedRequests);
        return false;
      }
    } catch (err) {
      console.error(`Error ${status === 'APPROVED' ? 'approving' : 'rejecting'} request:`, err);
      if (err.response) {
        console.error("Error response status:", err.response.status);
        console.error("Error response data:", err.response.data);
      }

      const errorMessage = err.response?.data?.message ||
        err.message ||
        `Failed to ${status === 'APPROVED' ? 'approve' : 'reject'} request. Please try again.`;
      showNotification(errorMessage, 'error');


      const revertedRequests = requests.map(req =>
        req.id === id ? { ...req, status: 'PENDING' } : req
      );
      setRequests(revertedRequests);
      return false;
    }
  };


  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterSelect = (filter) => {
    setStatusFilter(filter);
    setFilterAnchorEl(null);
    setPagination((prev) => ({
      ...prev,
      page: 0
    }

    ));
  };

  // const filteredRequests = requests.filter(request => {

  //   if (statusFilter !== 'ALL' && request.status !== statusFilter) {
  //     return false;
  //   }


  //   return (
  //     request.employeeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     request.employeeId.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     request.leaveType.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     request.status.toLowerCase().includes(searchTerm.toLowerCase())
  //   );
  // });

  const handleChangePage = (event, newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,

    }))

  };

  const handleChangeRowsPerPage = (event) => {
    setPagination((prev) => ({
      ...prev,
      page: 0,
      limit: parseInt(event.target.value, 10),
    }))

  };

  const handleLeaveTypeSelect = (leaveTypeId) => {
    setSelectedLeaveTypeFilter(leaveTypeId);
    setFilterAnchorEl(null);
    setPagination((prev) => ({
      ...prev,
      page: 0
    }));
  };

  const handleViewDetails = (request) => {
    setSelectedRequest(request);
    setDetailsOpen(true);
  };

  const getStatusColor = (status) => {
    if (status === 'APPROVED') return theme.palette.success.main;
    if (status === 'REJECTED') return theme.palette.error.main;
    if (status === 'PENDING') return theme.palette.warning.main;
    return theme.palette.info.main;
  };

  // const pendingCount = requests.filter(req => req.status === 'PENDING').length;
  const pendingCount = pagination.totalRecords;

  const emptyRows =
    pagination.limit - Math.min(pagination.limit, pagination.totalPages - pagination.page * pagination.rowsPerPage);

  const handleEmployeeRowClick = (employee) => {
    setEmployeeDetailsData(employee);
    setApprovalComment('');
    setRejectionReason('');
    setActionTab(0);
    setOpenEmployeeDetails(true);
  };

  const handleActionTabChange = (event, newValue) => {
    setActionTab(newValue);
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <Box sx={{
      backgroundColor: '#f9fafc',
      p: 3,
      borderRadius: 2,
      minHeight: '100vh'
    }}>
      <Card
        elevation={0}
        sx={{
          mb: 3,
          p: 2,
          background: 'linear-gradient(135deg, #6b8df2 0%, #4a6cf7 100%)',
          color: 'white',
          borderRadius: 2
        }}
      >
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                Leave Requests
              </Typography>
              <Typography variant="body2">
                Manage employee leave requests efficiently
              </Typography>
            </Box>
            <Box>
            <Badge badgeContent={pendingCount} color="error">
              <Card sx={{ px: 3, py: 1, borderRadius: 4 }}>
                <Typography variant="subtitle2" color="primary.main" fontWeight={600}>
                  Pending Requests
                </Typography>
              </Card>
            </Badge>
            <IconButton sx={{color:'primary.main', background:'#FFFFFF', borderRadius:2, ml:2}} onClick={fetchLeaveRequests}>
              <Refresh />
            </IconButton>
          </Box>
          </Box>
        </CardContent>
      </Card>
      <Card sx={{
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        border: '1px solid rgba(0,0,0,0.05)'
      }}>
        <Box sx={{
          p: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid rgba(0,0,0,0.05)'
        }}>
          <Typography variant="h6" fontWeight="600">Leave Requests</Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              placeholder="Search by Name"
              size="small"
              value={searchTerm}
              onChange={handleSearch}
              InputProps={{
                startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} />,
                sx: { borderRadius: '12px' }
              }}
            />

            {/* Leave Types Filter Button with Menu */}
            <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={handleFilterClick}
              sx={{
                borderRadius: '12px',
                textTransform: 'none',
                fontWeight: 500
              }}
            >
              {selectedLeaveTypeFilter === '' ? 'All Leave Types' :
                allLeaveTypes.find(leave => leave.id === selectedLeaveTypeFilter)?.leave_type || 'Leave Type'}
            </Button>

            <Menu
              anchorEl={filterAnchorEl}
              open={Boolean(filterAnchorEl)}
              onClose={handleFilterClose}
            >
              <MenuItem onClick={() => handleLeaveTypeSelect('')}>All</MenuItem>
              {allLeaveTypes && allLeaveTypes.length > 0 ? (
                allLeaveTypes.map((leave) => (
                  <MenuItem
                    onClick={() => handleLeaveTypeSelect(leave.id)}
                    key={leave.id}
                  >
                    {leave.leave_type}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>Loading leave types...</MenuItem>
              )}
            </Menu>
          </Box>
        </Box>
        {loading ? (
          <Box sx={{ p: 4, textAlign: 'center' }}>
            <Typography>Loading leave requests...</Typography>
          </Box>
        ) : error ? (
          <Box sx={{ p: 4, textAlign: 'center', color: 'error.main' }}>
            <Typography>{error}</Typography>
            <Button
              variant="contained"
              onClick={fetchLeaveRequests}
              sx={{ mt: 2 }}
            >
              Retry
            </Button>
          </Box>
        ) : requests.length === 0 ? (
          <Box sx={{ p: 4, textAlign: 'center' }}>
            <Typography>No leave requests found.</Typography>
          </Box>
        ) : (
          <>
            <TableContainer>
              <Table>
                <TableHead sx={{ backgroundColor: alpha('#f8fafc', 0.5) }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: '#475569', py: 2 }}>Employee</TableCell>
                    <TableCell sx={{ fontWeight: 600, color: '#475569', py: 2 }}>Department</TableCell>
                    <TableCell sx={{ fontWeight: 600, color: '#475569', py: 2 }}>Leave Type</TableCell>
                    <TableCell sx={{ fontWeight: 600, color: '#475569', py: 2 }}>Duration</TableCell>
                    <TableCell sx={{ fontWeight: 600, color: '#475569', py: 2 }}>Days</TableCell>
                    <TableCell sx={{ fontWeight: 600, color: '#475569', py: 2 }}>Status</TableCell>
                    {/* <TableCell sx={{ fontWeight: 600, color: '#475569', py: 2 }}>Actions</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {requests
                    .map((request) => (
                      <TableRow
                        key={request.id}
                        hover
                        sx={{
                          '&:hover': {
                            backgroundColor: '#f5f9ff'
                          },
                          transition: 'background-color 0.2s ease'
                        }}
                        onClick={() => handleEmployeeRowClick(request)}
                      >
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Avatar
                              sx={{
                                bgcolor: leaveTypeColors[request.leaveType] || '#9e9e9e',
                                width: 36,
                                height: 36,
                                fontSize: '0.9rem'
                              }}
                            >
                              {request.avatar}
                            </Avatar>
                            <Box>
                              <Typography sx={{ fontWeight: 500, color: '#37474f' }}>{request.employeeName}</Typography>
                              <Typography variant="caption" sx={{ color: '#78909c' }}>{request.employeeId}</Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography sx={{ color: '#455a64' }}>{request.department}</Typography>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={request.leaveType}
                            size="small"
                            sx={{
                              backgroundColor: `${leaveTypeColors[request.leaveType] || '#9e9e9e'}15`,
                              color: leaveTypeColors[request.leaveType] || '#9e9e9e',
                              fontWeight: 500,
                              borderRadius: 1,
                              '& .MuiChip-label': { px: 1 }
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <EventIcon fontSize="small" sx={{ color: '#9e9e9e', mr: 0.5 }} />
                            <Box>
                              <Typography variant="body2" sx={{ color: '#455a64' }}>
                                {new Date(request.fromDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                              </Typography>
                              <Typography variant="caption" sx={{ color: '#78909c' }}>
                                to {new Date(request.toDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              color: request.days > 5 ? '#f57c00' : '#455a64'
                            }}
                          >
                            {request.days}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={request.status}
                            size="small"
                            sx={{
                              backgroundColor: `${getStatusColor(request.status)}15`,
                              color: getStatusColor(request.status),
                              fontWeight: 500,
                              borderRadius: 1,
                              '& .MuiChip-label': { px: 1 }
                            }}
                          />
                        </TableCell>
                        {/* <TableCell>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Tooltip title="View Details">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleViewDetails(request)}
                              sx={{
                                bgcolor: 'primary.light',
                                color: 'white',
                                '&:hover': { bgcolor: 'primary.main' },
                                transition: 'all 0.2s'
                              }}
                            >
                              <InfoIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell> */}
                      </TableRow>
                    ))}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 49 * emptyRows }}>
                      <TableCell colSpan={7} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
          borderTop: '1px solid rgba(0,0,0,0.05)'
        }}>
          <Typography variant="body2" color="text.secondary">
            {/* Showing {Math.min(filteredRequests.length, page * rowsPerPage + 1)}-
            {Math.min(filteredRequests.length, page * rowsPerPage + rowsPerPage)} of {filteredRequests.length} results */}
          </Typography>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={pagination.totalRecords || 0}
            rowsPerPage={pagination.limit}
            page={pagination.page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              '.MuiTablePagination-toolbar': {
                paddingLeft: 0,
              },
              '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                margin: 0,
              }
            }}
            labelDisplayedRows={({ from, to, count }) =>
              `Showing ${from}-${to} of ${count}`
            }
          />
        </Box>
      </Card>

      <Dialog
        open={openEmployeeDetails}
        onClose={() => setOpenEmployeeDetails(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '16px',
          },
        }}
      >
        {employeeDetailsData && (
          <>
            <Box
              sx={{
                background: 'linear-gradient(90deg, #1976d2 0%, #2196f3 100%)',
                p: 3,
                color: 'white',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Avatar sx={{ width: 56, height: 56, bgcolor: '#1565c0', mr: 2 }}>
                  {employeeDetailsData.avatar}
                </Avatar>
                <Box>
                  <Typography variant="h5" fontWeight="500">
                    {employeeDetailsData.name}
                  </Typography>
                  <Typography variant="subtitle1">
                    {employeeDetailsData.workingIn}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <DialogContent sx={{ p: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Card sx={{ mb: 3, boxShadow: 2, borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
                        Leave Request Details
                      </Typography>

                      <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Reporting Supervisor
                        </Typography>
                        <Typography variant="body1">
                          {employeeDetailsData.reportingManager}
                        </Typography>
                      </Box>

                      <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Leave Type
                        </Typography>
                        <Typography variant="body1">
                          {employeeDetailsData.leaveType}
                        </Typography>
                      </Box>

                      <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Duration
                        </Typography>
                        <Typography variant="body1">
                          {employeeDetailsData.duration} day(s)
                        </Typography>
                      </Box>

                      <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Start Date
                        </Typography>
                        <Typography variant="body1">
                          {formatDate(employeeDetailsData.startDate)}
                        </Typography>
                      </Box>

                      <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary">
                          End Date
                        </Typography>
                        <Typography variant="body1">
                          {formatDate(employeeDetailsData.endDate)}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography variant="subtitle2" color="text.secondary">
                          Reason
                        </Typography>
                        <Typography variant="body1">
                          {employeeDetailsData.reason}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Card sx={{ boxShadow: 2, borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
                        Action
                      </Typography>

                      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                        <Tabs value={actionTab} onChange={handleActionTabChange} aria-label="action tabs">
                          <Tab
                            label="Approve"
                            sx={{
                              color: actionTab === 0 ? '#2e7d32' : 'inherit',
                              '&.Mui-selected': { color: '#2e7d32' }
                            }}
                          />
                          <Tab
                            label="Reject"
                            sx={{
                              color: actionTab === 1 ? '#c62828' : 'inherit',
                              '&.Mui-selected': { color: '#c62828' }
                            }}
                          />
                        </Tabs>
                      </Box>

                      {actionTab === 0 && (
                        <Box>
                          <TextField
                            fullWidth
                            label="Approval Comments (Optional)"
                            multiline
                            rows={4}
                            value={approvalComment}
                            onChange={(e) => setApprovalComment(e.target.value)}
                            sx={{ mb: 3 }}
                          />

                          <Button
                            fullWidth
                            variant="contained"
                            color="success"
                            onClick={() => handleLeaveApproval(employeeDetailsData.id, 'approve', approvalComment)}
                            disabled={employeeDetailsData.status !== 'PENDING'}
                            sx={{
                              py: 1.5,
                              borderRadius: 2,
                              fontWeight: 'bold',
                              boxShadow: 2,
                            }}
                          >
                            Approve Leave Request
                          </Button>

                          {employeeDetailsData.status !== 'PENDING' && (
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, textAlign: 'center' }}>
                              This request has already been {employeeDetailsData.status.toLowerCase()}
                            </Typography>
                          )}
                        </Box>
                      )}

                      {actionTab === 1 && (
                        <Box>
                          <TextField
                            fullWidth
                            label="Rejection Reason"
                            multiline
                            rows={4}
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                            required
                            error={rejectionReason.trim() === ''}
                            helperText={rejectionReason.trim() === '' ? 'Rejection reason is required' : ''}
                            sx={{ mb: 3 }}
                          />

                          <Button
                            fullWidth
                            variant="contained"
                            color="error"
                            onClick={() => handleLeaveApproval(employeeDetailsData.id, 'reject')}
                            disabled={employeeDetailsData.status !== 'PENDING' || rejectionReason.trim() === ''}
                            sx={{
                              py: 1.5,
                              borderRadius: 2,
                              fontWeight: 'bold',
                              boxShadow: 2,
                            }}
                          >
                            Reject Leave Request
                          </Button>

                          {employeeDetailsData.status !== 'PENDING' && (
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, textAlign: 'center' }}>
                              This request has already been {employeeDetailsData.status.toLowerCase()}
                            </Typography>
                          )}
                        </Box>
                      )}
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card sx={{ boxShadow: 2, borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 3, color: '#1976d2' }}>
                        Leave Balance
                      </Typography>

                      <Grid container spacing={3}>
                        {/* Regular Leaves Column */}
                        <Grid item xs={12} md={6}>
                          <Box sx={{
                            p: 2,
                            border: '1px solid #e0e0e0',
                            borderRadius: 2,

                          }}>
                            <Typography variant="subtitle1" sx={{ mb: 2, color: '#1976d2', fontWeight: 500 }}>
                              Regular Leaves
                            </Typography>
                            {Object.entries(employeeDetailsData.statistics)
                              .filter(([type, data]) =>
                                data.leaveTypeName !== "Work From Home" &&
                                data.leaveTypeName !== "Loss Of Pay" &&
                                data.total !== null
                              )
                              .map(([type, data]) => (
                                <Box key={type} sx={{ mb: 2.5 }}>
                                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
                                      {data.leaveTypeName}
                                    </Typography>
                                    <Typography variant="subtitle2" sx={{ color: '#1976d2' }}>
                                      {data.remaining}/{data.total} days
                                    </Typography>
                                  </Box>
                                  <LinearProgress
                                    variant="determinate"
                                    value={(data.used / data.total) * 100}
                                    sx={{
                                      height: 8,
                                      borderRadius: 4,
                                      mb: 1,
                                      backgroundColor: alpha('#1976d2', 0.1),
                                      '& .MuiLinearProgress-bar': {
                                        backgroundColor: '#1976d2',
                                      }
                                    }}
                                  />
                                  <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    fontSize: '0.75rem',
                                    color: '#757575'
                                  }}>
                                    <span>Total: {data.total}</span>
                                    <span>Used: {data.used}</span>
                                    <span>Remaining: {data.remaining}</span>
                                  </Box>
                                </Box>
                              ))}
                          </Box>
                        </Grid>

                        {/* Special Leaves Column */}
                        <Grid item xs={12} md={6}>
                          <Box sx={{
                            p: 2,
                            border: '1px solid #e0e0e0',
                            borderRadius: 2,

                          }}
                          >
                            <Typography variant="subtitle1" sx={{ mb: 2, color: '#1976d2', fontWeight: 500 }}>
                              Other Leaves
                            </Typography>
                            {Object.entries(employeeDetailsData.statistics)
                              .filter(([type, data]) =>
                                data.leaveTypeName === "Work From Home" ||
                                data.leaveTypeName === "Loss Of Pay"
                              )
                              .map(([type, data]) => (
                                <Box key={type} sx={{ mb: 2, }}>
                                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                    {data.leaveTypeName}
                                  </Typography>
                                  <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    backgroundColor: '#f5f5f5',
                                    p: 1,
                                    borderRadius: 2,
                                    height: '100%' // Ensure container has explicit height
                                  }}>
                                    <Box sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 1,
                                      height: '100%' // Match parent height
                                    }}>
                                      <Typography variant="subtitle2" color="text.secondary" sx={{ lineHeight: 1 }}>
                                        Used:
                                      </Typography>
                                      <Typography variant="body1" sx={{
                                        fontWeight: 500,
                                        lineHeight: 1
                                      }}>
                                        {data.used} days
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                              ))}
                          </Box>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </DialogContent>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 3,
                background: '#f8f9fa',
                borderTop: '1px solid #eee',
                borderBottomLeftRadius: '16px',
                borderBottomRightRadius: '16px',
              }}
            >
              <Button
                onClick={() => setOpenEmployeeDetails(false)}
                variant="outlined"
                sx={{ borderRadius: 8, px: 3, py: 1 }}
              >
                Close
              </Button>
            </Box>
          </>
        )}
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%', boxShadow: 3, borderRadius: 2 }}
          action={snackbar.action}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>


      <Modal
        open={openTokenExpirePopup}
        onClose={handleCloseTokenExpirePopup}
        aria-labelledby="token-expire-modal-title"
        aria-describedby="token-expire-modal-description"
      >
        <TokenExpirePopup onClose={handleCloseTokenExpirePopup} />
      </Modal>

      {/* <Dialog
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden'
          }
        }}
      >
        {selectedRequest && (
          <>
            <DialogTitle sx={{
              bgcolor: 'primary.main',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}>
              <IconButton
                size="small"
                onClick={() => setDetailsOpen(false)}
                sx={{ color: 'white', mr: 1 }}
              >
                <ArrowBackIcon />
              </IconButton>
              Leave Request Details
            </DialogTitle>
            <DialogContent sx={{ pt: 3, px: 4 }}>
              <Box sx={{ display: 'flex', mb: 3, alignItems: 'center', gap: 2 }}>
                <Avatar
                  sx={{
                    bgcolor: leaveTypeColors[selectedRequest.leaveType] || '#9e9e9e',
                    width: 56,
                    height: 56,
                    fontSize: '1.2rem'
                  }}
                >
                  {selectedRequest.avatar}
                </Avatar>
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#37474f' }}>
                    {selectedRequest.employeeName}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#78909c' }}>
                    {selectedRequest.employeeId} • {selectedRequest.department}
                  </Typography>
                </Box>
                <Chip
                  label={selectedRequest.status}
                  sx={{
                    ml: 'auto',
                    backgroundColor: `${getStatusColor(selectedRequest.status)}15`,
                    color: getStatusColor(selectedRequest.status),
                    fontWeight: 500,
                    borderRadius: 1,
                    '& .MuiChip-label': { px: 2 }
                  }}
                />
              </Box>
              <Divider sx={{ my: 2 }} />
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Card variant="outlined" sx={{ height: '100%', borderRadius: 2, borderColor: '#e0e0e0' }}>
                    <CardContent>
                      <Typography variant="subtitle2" sx={{ color: '#78909c', mb: 1 }}>
                        Leave Information
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Box sx={{ width: '40%' }}>
                          <Typography variant="body2" sx={{ color: '#546e7a', fontWeight: 500 }}>
                            Leave Type
                          </Typography>
                        </Box>
                        <Box sx={{ width: '60%' }}>
                          <Chip
                            label={selectedRequest.leaveType}
                            size="small"
                            sx={{
                              backgroundColor: `${leaveTypeColors[selectedRequest.leaveType] || '#9e9e9e'}15`,
                              color: leaveTypeColors[selectedRequest.leaveType] || '#9e9e9e',
                              fontWeight: 500,
                              borderRadius: 1,
                              '& .MuiChip-label': { px: 1 }
                            }}
                          />
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Box sx={{ width: '40%' }}>
                          <Typography variant="body2" sx={{ color: '#546e7a', fontWeight: 500 }}>
                            From Date
                          </Typography>
                        </Box>
                        <Box sx={{ width: '60%' }}>
                          <Typography variant="body2" sx={{ color: '#37474f' }}>
                            {new Date(selectedRequest.fromDate).toLocaleDateString('en-US', {
                              weekday: 'short',
                              month: 'short',
                              day: 'numeric',
                              year: 'numeric'
                            })}
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Box sx={{ width: '40%' }}>
                          <Typography variant="body2" sx={{ color: '#546e7a', fontWeight: 500 }}>
                            To Date
                          </Typography>
                        </Box>
                        <Box sx={{ width: '60%' }}>
                          <Typography variant="body2" sx={{ color: '#37474f' }}>
                            {new Date(selectedRequest.toDate).toLocaleDateString('en-US', {
                              weekday: 'short',
                              month: 'short',
                              day: 'numeric',
                              year: 'numeric'
                            })}
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ width: '40%' }}>
                          <Typography variant="body2" sx={{ color: '#546e7a', fontWeight: 500 }}>
                            Duration
                          </Typography>
                        </Box>
                        <Box sx={{ width: '60%' }}>
                          <Typography variant="body2" sx={{
                            color: '#37474f',
                            fontWeight: 600,
                            bgcolor: '#f5f5f5',
                            px: 1.5,
                            py: 0.5,
                            borderRadius: 1,
                            display: 'inline-block'
                          }}>
                            {selectedRequest.days} day{selectedRequest.days > 1 ? 's' : ''}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card variant="outlined" sx={{ height: '100%', borderRadius: 2, borderColor: '#e0e0e0' }}>
                    <CardContent>
                      <Typography variant="subtitle2" sx={{ color: '#78909c', mb: 1 }}>
                        Request Information
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Box sx={{ width: '40%' }}>
                          <Typography variant="body2" sx={{ color: '#546e7a', fontWeight: 500 }}>
                            Applied On
                          </Typography>
                        </Box>
                        <Box sx={{ width: '60%' }}>
                          <Typography variant="body2" sx={{ color: '#37474f' }}>
                            {new Date(selectedRequest.appliedOn).toLocaleDateString('en-US', {
                              month: 'short',
                              day: 'numeric',
                              year: 'numeric'
                            })}
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                        <Box sx={{ width: '40%', pt: 0.5 }}>
                          <Typography variant="body2" sx={{ color: '#546e7a', fontWeight: 500 }}>
                            Status
                          </Typography>
                        </Box>
                        <Box sx={{ width: '60%' }}>
                          <Chip
                            label={selectedRequest.status}
                            size="small"
                            sx={{
                              backgroundColor: `${getStatusColor(selectedRequest.status)}15`,
                              color: getStatusColor(selectedRequest.status),
                              fontWeight: 500,
                              borderRadius: 1,
                              '& .MuiChip-label': { px: 1 }
                            }}
                          />
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                {selectedRequest.reason && (
                  <Grid item xs={12}>
                    <Card variant="outlined" sx={{ borderRadius: 2, borderColor: '#e0e0e0' }}>
                      <CardContent>
                        <Typography variant="subtitle2" sx={{ color: '#78909c', mb: 2 }}>
                          Reason for Leave
                        </Typography>
                        <Paper
                          variant="outlined"
                          sx={{
                            p: 2,
                            bgcolor: '#f8f9fa',
                            borderColor: '#e0e0e0',
                            borderRadius: 2
                          }}
                        >
                          <Typography variant="body2" sx={{ color: '#37474f', lineHeight: 1.6 }}>
                            {selectedRequest.reason}
                          </Typography>
                        </Paper>
                      </CardContent>
                    </Card>
                  </Grid>
                )}

                
              </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 3, bgcolor: '#f5f7fa', borderTop: '1px solid #e0e0e0' }}>
              {selectedRequest.status === 'PENDING' && (
                <>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => handleApproveReject(selectedRequest.id, 'APPROVED')}
                    startIcon={<CheckIcon />}
                    sx={{
                      borderRadius: 2,
                      textTransform: 'none',
                      px: 3,
                      boxShadow: 2
                    }}
                  >
                    Approve Request
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleApproveReject(selectedRequest.id, 'REJECTED')}
                    startIcon={<CloseIcon />}
                    sx={{
                      borderRadius: 2,
                      textTransform: 'none',
                      px: 3,
                      boxShadow: 2
                    }}
                  >
                    Reject Request
                  </Button>
                </>
              )}
              <Button
                onClick={() => setDetailsOpen(false)}
                variant="outlined"
                               sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  color: '#546e7a',
                  borderColor: '#cfd8dc',
                  '&:hover': {
                    borderColor: '#b0bec5',
                    bgcolor: '#f5f5f5'
                  }
                }}
              >
                Close
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog> */}
    </Box>
  );
};


export default LeaveRequestsWithSnackbar;